import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@vendure/admin-ui/core';
import {OrderChartWidgetComponent} from './order-chart-widget.component';
import {ChartModule} from '../../chart/chart.module';

@NgModule({
  imports: [CommonModule, SharedModule, ChartModule],
  declarations: [OrderChartWidgetComponent],
  exports: [OrderChartWidgetComponent],
})
export class OrderChartWidgetModule {}
